<div class="flex-centered-container-column plans-status-bg plans-status-root status-container">
    <div class="status-content bg-white border-radius-12 pad-32" [ngClass]="'status-content--' + status">
        <!-- Icon Section -->
        <div class="icon-wrapper display-flex justify-center margin-24-bottom">
            <div class="icon-box flex-centered-container border-radius-full pad-24" [ngClass]="config.iconClass">
                <mat-icon class="icon" [ngClass]="config.infoIconClass" [class.icon-spin]="status === SubscriptionStatus.VERIFYING">{{ config.icon }}</mat-icon>
            </div>
        </div>

        <!-- Text Content -->
        <div class="text-content text-center margin-24-bottom">
            <h2 class="status-title font-bold no-margin margin-8-bottom font-24 primary-dark-text">{{ config.title }}</h2>
            <p class="status-subtitle no-margin font-14 text-dark">{{ config.subtitle }}</p>
        </div>

        <!-- Progress Bar -->
        <div *ngIf="config.showProgress" class="progress-wrapper margin-24-bottom">
            <div class="progress-track">
                <div class="progress-bar bg-primary"></div>
            </div>
        </div>

        <!-- Info Message -->
        <div class="info-message display-flex gap-16-px pad-12-vr pad-16-hr border-radius-8 font-14" [ngClass]="config.warningClass">
            <mat-icon class="info-message-icon" [ngClass]="config.infoIconClass">{{ config.warningIcon }}</mat-icon>
            <p class="info-message-text no-margin" [ngClass]="config.infoTextClass">{{ config.warning }}</p>
        </div>

        <!-- Action Buttons -->
        <div *ngIf="status === SubscriptionStatus.FAILURE" class="action-buttons display-flex gap-8-px margin-24-top">
            <button class="btn btn-primary bg-primary fg-white cursor-pointer border-radius-8 font-500 pad-12-vr pad-16-hr no-border" (click)="onGoBack()">Go Back</button>
        </div>
    </div>

    <!-- Footer -->
    <p class="footer-text text-center font-13 placeholder-text margin-24-top">Secured by uTrade Algos</p>
</div>